import React, { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import CustomActionMenu from "@components/CustomActionMenu/CustomActionMenu";
import CustomHeader from "@components/CustomHeader/CustomHeader";
import CustomTable from "@components/CustomTable/CustomTable";
import Loader from "@components/Loader/Loader";
import { CreateModalContext } from "layouts/appLayout/layout";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

import CreateProjectComponent from "../CreateProjectComponent/CreateProjectComponent";
import { useGetProjectsByCollaboratorQuery } from "store/project/project.api";

const ProjectsPageCollab = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentUser = useSelector((state) => state.auth.user);

  const [openMenuId, setOpenMenuId] = useState(null);
  const { toggleCreateModal } = useContext(CreateModalContext);

  const { data: projects, isLoading: isLoadingProjects } =
    useGetProjectsByCollaboratorQuery(currentUser?._id);

  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  const headers = [
    { key: "title", label: t("projects.form.title") },
    { key: "description", label: t("projects.form.description") },
    { key: "startDate", label: t("projects.form.startDate") },
    { key: "endDate", label: t("projects.form.endDate") },
    { key: "createdAt", label: t("projects.table.createdAt") },
  ];

  const renderCell = (key, project) => {
    if (key === "startDate" || key === "endDate" || key === "createdAt") {
      return project[key] ? new Date(project[key]).toLocaleDateString() : "-";
    }
    return project[key] || "-";
  };

  const handleEditProject = (project) => {
    setOpenMenuId(null);
    toggleCreateModal(
      <CreateProjectComponent
        onClose={() => toggleCreateModal(<></>)}
        project={project}
        isUpdate={true}
      />,
      t("projects.form.title_edit")
    );
  };

  const onSearchProject = (text) => {
    setSearchText(text.toLowerCase());
    setCurrentPage(0); // reset pagination quand on fait une recherche
  };

  const filteredProjects = useMemo(() => {
    if (!projects?.data?.projects) return [];
    if (searchText.length <= 1) return projects.data.projects;

    return projects?.data?.projects.filter((project) => {
      const title = project.title?.toLowerCase() || "";
      const description = project.description?.toLowerCase() || "";
      return title.includes(searchText) || description.includes(searchText);
    });
  }, [projects?.data?.projects, searchText]);

  // Pagination
  const pageCount = Math.ceil(filteredProjects.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;
  const currentItems = filteredProjects.slice(offset, offset + itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  if (isLoadingProjects) return <Loader />;

  return (
    <div className="p-5" style={{ overflowX: "auto" }}>
      <CustomHeader
        title={t("projects.header_title")}
        dataLength={filteredProjects.length}
        onSearch={onSearchProject}
      />
      <CustomTable
        headers={headers}
        data={currentItems}
        rowKey="_id"
        renderCell={renderCell}
      />

      {/* ✅ Pagination en bas */}

      <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
        <ReactPaginate
          previousLabel={"←"}
          nextLabel={"→"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={1}
          pageRangeDisplayed={2}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
          forcePage={currentPage}
        />
      </div>
    </div>
  );
};

export default ProjectsPageCollab;
